import styled from "styled-components";

export const Header = styled.h1`
  text-align: center;
  font-size: 32px;
  font-weight: 700;
  margin: 24px 0 40px 0;
`;
export const RingEmpty = styled.div`
  position: absolute;
  background-color: #f5f5f5;
  border: 16px solid #6f1d39;
  border-radius: 50%;
  z-index: -1;
  opacity: 0.15;
`;
export const RingFull = styled.div`
  position: absolute;
  background-color: #6f1d39;
  border-radius: 50%;
  z-index: -1;
  opacity: 0.15;
`;
